import { CANCEL_REQUEST_MESSAGE } from '../constants/common';

const handleResponse = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  // Сюда 401 доходит только если переаутентификация в попапе не помогла (см. api/authFetch).
  if (response.status === 401) {
    const error = new Error('Unauthorized');
    error.response = response;
    throw error;
  }

  if (response.status === 410) {
    const error = new Error();
    error.text = CANCEL_REQUEST_MESSAGE;

    throw error;
  }
  const error = new Error(response.statusText);
  error.response = response;
  error.text = await response.text();

  throw error;
};

export default handleResponse;
